import React, { Component } from 'react';
import {Auth} from 'aws-amplify';
import QRCode from 'qrcode';

class MultiFactorAuthenticationSetup extends Component {

  state = {
    MFASecret: '',
    inputMFACode: ''
  }

  componentDidMount() {
    this.handleRefresh();
  }

  render() {

    const {updateInput, handleAuthenticate, handleRefresh} = this;
    const {MFASecret, inputMFACode} = this.state;

    return (
      <div className="MultiFactorAuthenticationSetupPage">
        <h1>You Must Setup MFA To Access This Account</h1>
        <canvas id="MFAQRCodeCanvas"></canvas>
        <p>Code: {MFASecret}</p>
        <label htmlFor="inputMFACode">MFA Code</label>
        <input id="inputMFACode" value={inputMFACode} onChange={updateInput}/>
        <button onClick={handleAuthenticate}>Authenticate</button>
        <button onClick={handleRefresh}>Refresh</button>
      </div>
    );

  }

  updateInput = e => {
    this.setState({[e.target.id]: e.target.value});
  }

  handleAuthenticate = () => {

    const {pushToLog, firstTimeUser, updateUserState} = this.props;

    const formattedMFACode = this.state.inputMFACode.replace(/ /g, '');

    if (formattedMFACode.length !== 6) pushToLog('MFA code must be exactly six characters long.');
    else if (/[^0-9]/.test(formattedMFACode)) pushToLog('MFA code must only contain numbers.');
    else {

      Auth.verifyTotpToken(firstTimeUser, formattedMFACode)
      .then(res => {

        this.setState({inputMFACode: ''});
        pushToLog('MFA Device Set Up Successfully.');
        updateUserState({firstTimeUser: {}, challengeName: 'VERIFY_EMAIL'});

      })
      .catch(err => {

        if (err.message === 'Invalid session for the user, session is expired.') {
          pushToLog('Your session expired. Please log in again.');
          updateUserState({firstTimeUser: {}, challengeName: 'LOGGED_OUT'});
        } else if (err.message === 'Code mismatch and fail enable Software Token MFA') {
          pushToLog('Invalid MFA token.');
        } else {
          console.log(err);
        }

      });

    }
  }

  handleRefresh = () => {

    const {firstTimeUser} = this.props;

    Auth.setupTOTP(firstTimeUser)
    .then(res => {
      this.setState({MFASecret: res});
      QRCode.toCanvas(document.getElementById('MFAQRCodeCanvas'), `otpauth://totp/Weaveability%20Basis%20Utilities:${firstTimeUser.username}?secret=${res}&issuer=Weaveability%20Basis%20Utilities`);
    })
    .catch(err => {
      console.log(err);
    });

  }

}

export default MultiFactorAuthenticationSetup;


// WEBPACK FOOTER //
// ./src/components/content/user/userComponents/multiFactorAuthenticationSetup.js